import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('dashboard_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, error => Promise.reject(error));

API.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('dashboard_token');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const getStats = () => API.get('/stats');
export const getUsers = () => API.get('/users');
export const getUser = (id) => API.get('/users/' + id);
export const getVideos = (limit=50) => API.get('/videos?limit=' + limit);
export const getFinance = () => API.get('/finance');
export const getSystem = () => API.get('/system');
// D-276: per-server video-worker on/off
export const getWorkerStatus = () => API.get('/worker/status');
export const toggleWorker = (server, enabled) => API.post('/worker/toggle?server=' + server + '&enabled=' + enabled);
export const setWorkerMode = (server, mode) => API.post('/worker/set?server=' + server + '&mode=' + mode);  // D-276c: off|short|all
export const updateTrialUser = (id, days) => API.put('/users/' + id + '/trial?days=' + days);
export const updateTrialAll = (days) => API.put('/settings/trial_days?days=' + days);
export const getUserCostsByDate = (id) => API.get('/users/' + id + '/costs_by_date');
export const getUserActivity = (id, date) => API.get('/users/' + id + '/activity' + (date ? '?date=' + date : ''));
export const deleteUserActivity = (id, date) => API.delete('/users/' + id + '/activity?date=' + date);
export const deleteSessionActivity = (id, sessionStart) => API.delete('/users/' + id + '/activity/session?session_start=' + encodeURIComponent(sessionStart));
export const sendMessageToUser = (id, message) => API.post('/users/' + id + '/message?message=' + encodeURIComponent(message));
export const getAnthropicBilling = () => API.get('/billing/anthropic');
export const saveAnthropicBalance = (amount) => API.post('/billing/anthropic/balance', {}, { params: { amount: amount } });
export const saveOpenAIBalance = (amount) => API.post('/billing/openai/balance', {}, { params: { amount: amount } });
export const getOpenAIBilling = () => API.get('/billing/openai');
export const getCostsSummary = (dateFrom, dateTo) => API.get('/costs/summary' + (dateFrom ? '?date_from='+dateFrom+(dateTo?'&date_to='+dateTo:'') : ''));
export const getProcessingQueue = () => API.get('/processing-queue');
export const getExpenses = () => API.get('/expenses');
export const createExpense = (data) => API.post('/expenses', data);
export const deleteExpense = (id) => API.delete('/expenses/' + id);
export const updateExpense = (id, data) => API.put('/expenses/' + id, data);
export const getApiKeys = () => API.get('/api-keys');
export const sendBroadcast = (message) => API.post('/broadcast?message=' + encodeURIComponent(message));
export const saveApiKey = (service, key) => API.post('/api-keys/' + service + '?key=' + encodeURIComponent(key));
// SECURITY 2026-08-18 (M5): було склеювання URL без екранування —
// '/change-credentials?new_username=' + u + '&new_password=' + p.
// Пароль ішов у адресному рядку (а отже в логи nginx), і будь-який
// & + % чи пробіл у ньому ламав передачу. Тепер — у тілі запиту.
export const changeCredentials = (u, p, token) =>
  axios.post('/change-credentials', { new_username: u, new_password: p },
    { headers: { Authorization: 'Bearer ' + token } });

export default API;

// [Дедиковані сервери]
export const getDedicatedServers = () => API.get('/dedicated/list');
export const createDedicated = (name, stype) => API.post('/dedicated/create?name=' + encodeURIComponent(name) + (stype ? '&stype=' + encodeURIComponent(stype) : ''));
export const getDedicatedServerTypes = () => API.get('/dedicated/server-types');
export const adoptDedicated = (data) => API.post('/dedicated/adopt', data);
export const deleteDedicated = (name) => API.post('/dedicated/delete?name=' + encodeURIComponent(name));
export const getDedicatedUsers = () => API.get('/dedicated/users');
export const assignDedicated = (userId, serverName) => API.post('/dedicated/assign?user_id=' + userId + '&server_name=' + encodeURIComponent(serverName));
export const unassignDedicated = (userId) => API.post('/dedicated/unassign?user_id=' + userId);
export const setDedicatedConcurrency = (name, value) => API.post('/dedicated/concurrency?name=' + encodeURIComponent(name) + '&value=' + value);
export const setDedicatedMode = (name, value) => API.post('/dedicated/mode?name=' + encodeURIComponent(name) + '&value=' + value);
export const getUpgradeOptions = (stype, disk) => API.get('/dedicated/upgrade-options?stype=' + encodeURIComponent(stype) + (disk ? '&disk=' + disk : ''));
export const getCoreServers = () => API.get('/dedicated/core-servers');
export const upgradeDedicated = (name, stype) => API.post('/dedicated/upgrade?name=' + encodeURIComponent(name) + '&stype=' + encodeURIComponent(stype));
export const setWorkerConcurrency = (ip, value) => API.post('/worker/concurrency?ip=' + ip + '&value=' + value);
